import { useT } from "@/i18n/I18nContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ variant = "sidebar" }) {
  const { lang, setLang, languages } = useT();

  if (variant === "icon") {
    // Ultra-compact: shows only the current flag emoji — used in the mobile top bar
    const current = languages.find((l) => l.code === lang);
    return (
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger
          data-testid="lang-switcher-icon"
          className="h-8 w-8 p-0 rounded-full bg-[#5A8B8F]/10 border-0 justify-center text-sm [&>svg]:hidden"
          aria-label="Language"
        >
          <span className="leading-none">{current?.flag || "🌐"}</span>
        </SelectTrigger>
        <SelectContent align="end">
          {languages.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>{l.flag} {l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  if (variant === "compact") {
    return (
      <Select value={lang} onValueChange={setLang}>
        <SelectTrigger data-testid="lang-switcher-compact" className="h-9 w-auto bg-white/10 border-white/20 text-white text-sm gap-1">
          <Globe className="h-3.5 w-3.5" />
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          {languages.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>{l.flag} {l.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Select value={lang} onValueChange={setLang}>
      <SelectTrigger data-testid="lang-switcher" className="h-9 text-sm bg-white border-slate-200 gap-2">
        <Globe className="h-3.5 w-3.5 text-slate-500" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {languages.map((l) => (
          <SelectItem key={l.code} value={l.code} data-testid={`lang-opt-${l.code}`}>{l.flag} {l.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
